import React, { useState, useEffect } from 'react';
import { Phone, Menu, X } from 'lucide-react';
import { businessInfo } from '../data/mock';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header className={`fixed top-0 w-full z-50 transition-all duration-300 ${
      isScrolled ? 'bg-black/95 backdrop-blur-md shadow-lg shadow-purple-500/10' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <div className="flex items-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_bilservice-gavle/artifacts/2ug1w9wo_GADEP-Picsart-BackgroundRemover.jpg" 
              alt="Gävles Autodepå" 
              className="h-16 w-auto transition-all duration-300 hover:scale-105"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button onClick={() => scrollToSection('services')} className="text-gray-300 hover:text-purple-400 transition-colors duration-300 font-medium">
              Tjänster
            </button>
            <button onClick={() => scrollToSection('about')} className="text-gray-300 hover:text-purple-400 transition-colors duration-300 font-medium">
              Om Oss
            </button>
            <button onClick={() => scrollToSection('process')} className="text-gray-300 hover:text-purple-400 transition-colors duration-300 font-medium">
              Så Fungerar Det
            </button>
            <button onClick={() => scrollToSection('reviews')} className="text-gray-300 hover:text-purple-400 transition-colors duration-300 font-medium">
              Recensioner
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-gray-300 hover:text-purple-400 transition-colors duration-300 font-medium">
              Kontakt
            </button>
            <a 
              href={`tel:${businessInfo.phone}`}
              className="bg-gradient-to-r from-purple-600 to-pink-600 text-white px-6 py-3 rounded-lg font-semibold flex items-center gap-2 hover:from-purple-700 hover:to-pink-700 transition-all duration-300 shadow-lg shadow-purple-500/30 hover:shadow-purple-500/50"
            >
              <Phone size={18} />
              Ring Nu
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button 
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-white p-2 hover:text-purple-400 transition-colors"
          >
            {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-black/98 border-t border-purple-500/20">
          <nav className="flex flex-col px-4 py-6 space-y-4">
            <button onClick={() => scrollToSection('services')} className="text-gray-300 hover:text-purple-400 transition-colors text-left py-2">
              Tjänster
            </button>
            <button onClick={() => scrollToSection('about')} className="text-gray-300 hover:text-purple-400 transition-colors text-left py-2">
              Om Oss
            </button>
            <button onClick={() => scrollToSection('process')} className="text-gray-300 hover:text-purple-400 transition-colors text-left py-2">
              Så Fungerar Det
            </button>
            <button onClick={() => scrollToSection('reviews')} className="text-gray-300 hover:text-purple-400 transition-colors text-left py-2">
              Recensioner
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-gray-300 hover:text-purple-400 transition-colors text-left py-2">
              Kontakt
            </button>
            <a 
              href={`tel:${businessInfo.phone}`}
              className="bg-gradient-to-r from-purple-600 to-pink-600 text-white px-6 py-3 rounded-lg font-semibold flex items-center justify-center gap-2 hover:from-purple-700 hover:to-pink-700 transition-all duration-300"
            >
              <Phone size={18} />
              Ring Nu
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};
